export const BILLING_CACHE_STALE_MS = 30_000;
export const BILLING_CATALOG_STALE_MS = 5 * 60_000;
